export default __webpack_public_path__ + "static/media/whiteBlackCity.34bd8b62.jpg";